import React, { FunctionComponent } from 'react'
import { DatePicker, InputWrapper, Switch } from '../../../shared'
import { PatientInformationsFormProps } from './PatientInformationsForm.model'
import styles from './PatientInformationsForm.module.scss'
import { addTestIdSuffix } from '../../../../misc/testId.utilities'

export const PatientInformationsForm: FunctionComponent<PatientInformationsFormProps> = ({
  patientInformations,
  setPatientInformations,
  testId,
}) => {
  return (
    <div
      className={styles.patientInformationsFormContainer}
      data-test-id={addTestIdSuffix('root', testId)}
    >
      <div className={styles.patientInformationsFormInstruction}>
        Merci de préciser les informations ci-dessous
      </div>
      <div className={styles.patientInformationsFormDetails}>
        <InputWrapper
          disabled={!!patientInformations.codedInformationId}
          title="Allergie, antécédent, pathologie ou commentaire"
        >
          <input
            className={styles.patientInformationsFormCodedInformation}
            disabled={!!patientInformations.codedInformationId}
            value={`${patientInformations.name}${
              patientInformations.codedInformation?.cim10
                ? ` (${patientInformations.codedInformation?.cim10})`
                : ''
            }`}
            onChange={(e) =>
              setPatientInformations({ ...patientInformations, name: e.currentTarget.value })
            }
            data-test-id={addTestIdSuffix('field-name', testId)}
          />
        </InputWrapper>
        <div className={styles.whiteBackground}>
          <DatePicker
            label="Date de début"
            value={patientInformations.startAt}
            onChange={(date) => setPatientInformations({ ...patientInformations, startAt: date })}
            placeholder="jj/mm/aaaa"
            showCalendarButton={false}
            clearable
            testId="date_picker-patient_informations-start"
          />
        </div>
        <div className={styles.whiteBackground}>
          <DatePicker
            label="Date de fin"
            value={patientInformations.endAt}
            onChange={(date) => setPatientInformations({ ...patientInformations, endAt: date })}
            placeholder="jj/mm/aaaa"
            showCalendarButton={false}
            clearable
            testId="date_picker-patient_informations-end"
          />
        </div>
        {patientInformations.codedInformation?.ald && (
          <div className={styles.patientInformationsFormCodedInformationAld}>
            <span
              className={styles.patientInformationsFormCodedInformationAldName}
            >{`ALD n°${patientInformations.codedInformation?.ald?.code} : ${patientInformations.codedInformation?.ald?.title}`}</span>
            <div className={styles.patientInformationsFormCodedInformationAldSwitch}>
              <Switch
                name="Marquer comme ALD pour le patient"
                checked={patientInformations.isAld}
                onChange={(checked) =>
                  setPatientInformations({ ...patientInformations, isAld: checked })
                }
                testId="switch-patient-is_ald"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
